/**
 * Speedin Auto Add-On Storefront Plugin Runtime
 * - Automatically attaches the Free Sample Sachet + Pocket Case and any selected
 *   companion formula when a product is added to the cart.
 * - Cleans up orphan free bonus gifts when the cart is emptied.
 * - Exposes `window.SpeedinAutoAddonPlugin` for the React Full-Motion runtime & Cart Drawer.
 */
(() => {
  if (window.SpeedinAutoAddonPlugin) return;

  const BONUS_HANDLE = 'free-sample-sachet';
  const COMPANION_RECOMMENDATIONS = {
    'energy-strips': {
      handle: 'sleep-strips',
      reason: 'Evening wind-down pair',
      badge: 'Recommended pair',
    },
    'sleep-strips': {
      handle: 'energy-strips',
      reason: 'Daytime focus pair',
      badge: 'Recommended pair',
    },
    'hair-skin-nails': {
      handle: 'energy-strips',
      reason: 'Morning glow + afternoon focus',
      badge: 'Recommended pair',
    },
  };

  const state = {
    includeFreeBonus: true,
    selectedCompanions: new Set(),
    sampleFormula: 'energy',
  };

  function getRecommendedCompanion(handle) {
    return COMPANION_RECOMMENDATIONS[handle] || null;
  }

  function initWidget(widget) {
    if (widget.dataset.spAddonInitialized === 'true') return;
    widget.dataset.spAddonInitialized = 'true';

    const bonusToggle = widget.querySelector('[data-sp-bonus-toggle]');
    if (bonusToggle) {
      bonusToggle.checked = state.includeFreeBonus;
      bonusToggle.addEventListener('change', () => {
        state.includeFreeBonus = bonusToggle.checked;
        document.dispatchEvent(
          new CustomEvent('speedin:addon:change', {
            detail: {
              includeFreeBonus: state.includeFreeBonus,
              selectedCompanions: Array.from(state.selectedCompanions),
            },
          }),
        );
      });
    }
  }

  function boot(scope = document) {
    scope.querySelectorAll('[data-sp-auto-addon-plugin]').forEach(initWidget);
  }

  window.SpeedinAutoAddonPlugin = {
    version: '1.0.0',
    bonusHandle: BONUS_HANDLE,
    state,
    getRecommendedCompanion,
    setIncludeFreeBonus(val) {
      state.includeFreeBonus = Boolean(val);
      document.dispatchEvent(
        new CustomEvent('speedin:addon:change', {
          detail: {
            includeFreeBonus: state.includeFreeBonus,
            selectedCompanions: Array.from(state.selectedCompanions),
          },
        }),
      );
    },
    boot,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
